"use strict"
exports.__esModule = true;
exports.BandcampIconConfig = {
  name: 'BandcampIcon',
  height: 512,
  width: 512,
  svgPath: 'M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z',
  yOffset: 0,
  xOffset: 0,
};
exports.BandcampIcon = require('../createIcon').createIcon(exports.BandcampIconConfig);
exports["default"] = exports.BandcampIcon;